import { Body16 } from '../../../Text';

const Subtitle = Body16;

export default Subtitle;
